module.exports = "/*\n*\n*   move to theme/default/modules/_corpus.scss\n*\n */\n"